import React, { useState, useEffect } from 'react';
import { Col, Row, Button, FormGroup, Label, Input, Alert, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import * as IoIcons from 'react-icons/io';
import Navbarh from '../navbar/Navbar';
import classnames from 'classnames';
import ProduccionCalidad from './ProduccionCalidad';
import Recuperacion from './Recuperacion';
import Cuarentena from './Cuarentena';
import Incoming from './Incoming';
import InspeccionPC from './InspeccionPC';
//import ImageUploader from 'react-images-upload';       

//Función principal 
function Calidad() {
    const [formType, setFormType] = useState('Calidad');
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [activeTab, setActiveTab] = useState('0');
    const [color, setColor] = useState("warning");
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);
    const pproduccionRecuperacion = window.$ProduccionRecuperacion ? window.$ProduccionRecuperacion : false;
    const pproduccionCalidad = window.$ProduccionCalidad ? window.$ProduccionCalidad : false;
    const pcalidad = window.$Calidad ? window.$Calidad : false;
    const pcuarentena = window.$Cuarentena ? window.$Cuarentena : false;
    const pincoming = window.$Incoming ? window.$Incoming : false;

    //Método useEffect que sirve para ejecutar funciones al abrir módulo
    useEffect(() => {
        //Poner función a ejecutar. ejemplo;
        //fetchClientes();        
    }, []);

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    };
    //Método useEffect
    useEffect(() => {
        if (pincoming === true)
            setActiveTab('2')
        else if (pcuarentena === true)
            setActiveTab('1')
        else if (pproduccionCalidad === true)
            setActiveTab('3')
        else if (pproduccionCalidad === true)
            setActiveTab('4')

    }, []);

    //Diseño de la página
    return (
        <>
            <Navbarh />
            {pcalidad === true && (
                <>
                    <row>
                        <div className="headerp">
                            <IoIcons.IoIosAperture className="iconoc floatleft" />
                            <h3 >{formType}</h3>
                        </div>
                    </row>
                    <div className="conteiner2">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}
                        <div>
                            <Nav tabs>
                                <NavItem className={pincoming === true ? "" : "displaynone"}>
                                    <NavLink
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => { toggle1('2'); }}
                                    >
                                        Incoming
                                    </NavLink>
                                </NavItem>
                                <NavItem className={pproduccionCalidad === true ? "" : "displaynone"}>
                                    <NavLink
                                        className={classnames({ active: activeTab === '3' })}
                                        onClick={() => { toggle1('3'); }}
                                    >
                                        Inspección final Ecoat
                                    </NavLink>
                                </NavItem>
                                <NavItem className={pproduccionCalidad === true ? "" : "displaynone"}>
                                    <NavLink
                                        className={classnames({ active: activeTab === '5' })}
                                        onClick={() => { toggle1('5'); }}
                                    >
                                        Inspección final Pcoat
                                    </NavLink>
                                </NavItem>
                                <NavItem className={"displaynone"}>{/*pproduccionRecuperacion === true ? "" :*/}
                                    <NavLink
                                        className={classnames({ active: activeTab === '4' })}
                                        onClick={() => { toggle1('4'); }}
                                    >
                                        Recuperación
                                    </NavLink>
                                </NavItem>
                                <NavItem className={pcuarentena === true ? "" : "displaynone"}>
                                    <NavLink
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { toggle1('1'); }}
                                    >
                                        Cuarentena
                                    </NavLink>
                                </NavItem>
                                <NavItem className="displaynone" >
                                    <NavLink
                                        className={classnames({ active: activeTab === '5' })}
                                        onClick={() => { toggle1('5'); }}
                                    >
                                        Imprimir
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <Cuarentena />
                                </TabPane>
                                <TabPane tabId="2">
                                    {activeTab === "2" && (
                                        <Incoming />)}
                                </TabPane>
                                <TabPane tabId="3">
                                    {activeTab === "3" && (
                                        <ProduccionCalidad />)}
                                </TabPane>
                                <TabPane tabId="4">
                                    <Recuperacion />
                                </TabPane>
                                <TabPane tabId="5" >
                                    {activeTab === "5" && (
                                        <InspeccionPC />
                                    )}
                                </TabPane>
                            </TabContent>
                        </div>


                    </div>
                </>
            )}
        </>
    )
}

export default Calidad